/**
 * FAQのアコーディオン
 */

export default class FaqAccordion {
  constructor(_parm) {
    this.parent = document.querySelector('#js-accordion') || false;
    if (!this.parent) return;
    this.faqItems = [...this.parent.querySelectorAll('.p-faq-list__item')];
    this.toggleClass = 'is-open';
  }

  toggle(_faqItem) {
    const answer = _faqItem.querySelector('.p-faq-list__answer');
    const question = _faqItem.querySelector('.p-faq-list__question');
    if (_faqItem.classList.contains(this.toggleClass)) {
      _faqItem.classList.remove(this.toggleClass);
      question.classList.remove(this.toggleClass);
      answer.classList.remove(this.toggleClass);
      return;
    }
    _faqItem.classList.add(this.toggleClass);
    question.classList.add(this.toggleClass);
    answer.classList.add(this.toggleClass);
  }

  addEvent(_faqItem) {
    const questionBtn = _faqItem.querySelector('.p-faq-list__question a');
    questionBtn.addEventListener('click', (_ev) => {
      this.toggle(_faqItem);
    });
  }

  init() {
    if (!this.parent) return;
    this.faqItems.forEach(_faqItem => {
      this.addEvent(_faqItem);
    });
  }
}